
interface UserProps {
    userDetails: any;
}

const UserDetailsSection = ({ userDetails = null }: UserProps) => {

    if (!userDetails) { return <></>; }
    return (
        <>
            {userDetails && (
               <div
  className="bg-white border rounded-3 shadow-sm px-3 px-md-4 py-3 mb-3 mt-4"
  style={{
    borderColor: "#e5e7eb",
  }}
>
  <div className="d-flex align-items-center flex-wrap gap-3">

    {/* Avatar */}
    <div
      className="d-flex align-items-center justify-content-center rounded-circle text-white fw-semibold flex-shrink-0"
      style={{
        width: 46,
        height: 46,
        background: "#2C2F7D",
        fontSize: 15,
        letterSpacing: "0.5px",
      }}
    >
      {userDetails?.name
        ?.split(" ")
        ?.filter(Boolean)
        ?.map((n: string) => n[0])
        ?.join("")
        ?.slice(0, 2)
        ?.toUpperCase()}
    </div>

    {/* User Name */}
    <div
      className="d-flex flex-column justify-content-center"
      style={{
        minWidth: 150,
      }}
    >
      <span
        className="fw-semibold text-capitalize text-dark"
        style={{
          fontSize: 15,
          lineHeight: "20px",
        }}
      >
        {userDetails?.name || "-"}
      </span>

     
    </div>

    {/* Divider */}
    <div
      className="vr d-none d-md-block"
      style={{
        height: 36,
        opacity: 0.15,
      }}
    />

    {/* Contact Details */}
    <div
      className="d-flex flex-wrap align-items-center gap-4 ms-md-1"
      style={{
        flex: 1,
      }}
    >
      {/* Email */}
      <div className="d-flex align-items-center gap-2">
        <div
          className="d-flex align-items-center justify-content-center rounded-2"
          style={{
            width: 32,
            height: 32,
            background: "#f1f2fb",
            color: "#2C2F7D",
            flexShrink: 0,
          }}
        >
          <i
            className="ti ti-mail"
            style={{ fontSize: 16 }}
          />
        </div>

        <div className="d-flex flex-column">
          <span
            className="text-muted"
            style={{
              fontSize: 11,
              lineHeight: "15px",
            }}
          >
            Email
          </span>

          <span
            className="fw-medium text-dark"
            style={{
              fontSize: 13,
              lineHeight: "18px",
              wordBreak: "break-word",
            }}
          >
            {userDetails?.email || "-"}
          </span>
        </div>
      </div>

      {/* Mobile */}
      <div className="d-flex align-items-center gap-2">
        <div
          className="d-flex align-items-center justify-content-center rounded-2"
          style={{
            width: 32,
            height: 32,
            background: "#f1f2fb",
            color: "#2C2F7D",
            flexShrink: 0,
          }}
        >
          <i
            className="ti ti-phone"
            style={{ fontSize: 16 }}
          />
        </div>

        <div className="d-flex flex-column">
          <span
            className="text-muted"
            style={{
              fontSize: 11,
              lineHeight: "15px",
            }}
          >
            Mobile
          </span>

          <span
            className="fw-medium text-dark"
            style={{
              fontSize: 13,
              lineHeight: "18px",
            }}
          >
            {userDetails?.mobile || "-"}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
            )}
        </>
    )
}

export default UserDetailsSection